import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchAdminQuestionnaireTemplates } from '@/api/(admin)/questionnaire-templates';
import type { AdminQuestionnaireTemplate } from '@/api/(admin)/questionnaire-templates/types';
import type { AdminTemplatesQueryInput } from '../-types';
import {
  buildAdminTemplatesQs,
  toAdminTemplatesParams,
} from '../-utils/listParams';

/** Prefix for every cache entry — what a write invalidates. */
export const adminQuestionnaireTemplatesQueryKey = [
  'admin',
  'questionnaire-templates',
] as const;

/** Shared by the route loader and the page, so the prefetch warms what the page reads. */
export function adminQuestionnaireTemplatesQueryOptions(
  input: AdminTemplatesQueryInput,
) {
  const params = toAdminTemplatesParams(input);
  return queryOptions({
    queryKey: [...adminQuestionnaireTemplatesQueryKey, 'list', params] as const,
    queryFn: () =>
      fetchAdminQuestionnaireTemplates(buildAdminTemplatesQs(params)),
  });
}

export function useAdminQuestionnaireTemplates(
  input: AdminTemplatesQueryInput,
) {
  const query = useQuery(adminQuestionnaireTemplatesQueryOptions(input));
  const rows: AdminQuestionnaireTemplate[] = query.data?.data ?? [];
  return {
    rows,
    totalCount: query.data?.metadata?.pagination?.total ?? 0,
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
